import React, { useEffect, useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaArrowLeft, FaEdit, FaEye, FaPlus, FaSave, FaTrash } from "react-icons/fa";

const ViewCbibDetail = ({ dataDetail, saveDetail, cancelDetail }) => {

    const [loading, setLoading] = useState()
    const [listDataDetail, setListDataDetail] = useState([])

    useEffect(() => {
        if (!dataDetail) return
        setLoading(true)
        setListDataDetail(dataDetail.data)
        // setTotalData(dataKomoditi.totalData)
        setLoading(false)
    }, [dataDetail])

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trUmkuBudidayaDetailPK'].seri,
            grow: 0
        },
        {
            name: 'Jenis Komoditi',
            cell: row => row['jenisKomoditi'],
        },
        {
            name: 'Umur',
            cell: row => row['umur']
        },
        {
            name: 'Ukuran',
            cell: row => row['ukuran']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-12 mb-1'>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Komoditi</Tooltip>}>
                                <Button size='sm' variant='info'>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        {localStorage.getItem('isEditPrimer') === '1' ?
                            <>
                                <div className='col-12 mb-1'>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Ubah Komoditi</Tooltip>}>
                                        <Button size='sm' variant='warning'>
                                            <FaEdit /> Ubah
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                                <div className='col-12 mb-1'>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Hapus Komoditi</Tooltip>}>
                                        <Button size='sm' variant='danger'>
                                            <FaTrash /> Hapus
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            ),
            grow: 1
        }
    ]

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuPrimerStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditPrimer') === '1' ?
                            <div className="col-7">
                                <Button type="button" variant="primary" size="sm"><FaPlus />Tambah Detil</Button>
                            </div> : ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listDataDetail}
                    highlightOnHover
                    pagination
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditPrimer') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveDetail('dokumen')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelDetail('entitas')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }
        </>
    )
}

export default ViewCbibDetail